import React from 'react';
import { Typography, Button, Avatar, Menu,TextField, Select, MenuItem,CircularProgress, Backdrop, Checkbox, FormGroup, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import API from '../API';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import SearchBarComponent from '../components/SearchBarComponent';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MultiSelectDropdown from '../components/MultiSelectDropdown';

const types = ["Motorsiklet", "Sedan", "Doblo", "Minivan", "Panelvan", "Kamyonet", "Esnek", "Kamyon (6 Teker)", "Kamyon (8 Teker)", "Kamyon (10 Teker)"];
const cityOptions = Object.values(API.allowedCities || {}).sort((a, b) => a.name.localeCompare(b.name, "tr"));
const defaultCityFilter = cityOptions.map((city) => city.id);
// Compact dropdown option lists (ADM-04) — long checkbox grids are gone.
const vehicleSelectOptions = types.map((label, value) => ({ value, label }));
const citySelectOptions = cityOptions.map((city) => ({ value: city.id, label: city.name }));
export default class NotificationCenter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          receiverType: undefined,
          notificationTemplatesDropdownOpen: false,
          filterType: undefined,
          filters: {},
          openAction: 0,
          selectedUsers: [],
          data: {},
          title: {en: "", tr: ""},
          body: {en: "", tr: ""},
          audienceSize: [0,0],
          approveSend: false,
          backdropVisible: false,
          cityFilter: defaultCityFilter,
          customerFilters: getDefaultCustomerFilters(),
          businesses: [],
          businessesLoading: false,
          templateName: "",
        };

        
       

        
    }

    componentDidMount() {
        const orderId = new URLSearchParams(this.props.location?.search || "").get("orderId");
        if (orderId) this.setState({data: {orderId}});
        this.setState({businessesLoading: true});
        API.getBusinesses().then((e) => {
          this.setState({businessesLoading: false, businesses: e?.businesses || []});
        }).catch(() => {
          this.setState({businessesLoading: false});
        });
    }
    render() {
        

        
        return <div style={{display:"flex", justifyContent:"center"}}>

            <div style={{maxWidth:900, width:"100%"}}>
            


            <Typography variant='h4' style={{marginBottom: 30}}>Bildirim Merkezi</Typography>

            <Badge>
                <Typography variant='h6'>Kitle Ayarları</Typography>
                <FormControl style={{marginTop:20}}>
      <FormLabel id="demo-row-radio-buttons-group-label">Alıcı Tipi</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={this.state.receiverType}
        onChange={(a) => this.setState({receiverType: a.target.value, selectedUsers: []})}
      >
        <FormControlLabel value={0} control={<Radio />} label="Müşteri" />
        <FormControlLabel value={1} control={<Radio />} label="Sürücü" />
        
        
      </RadioGroup>
    </FormControl>


    <FormControl style={{marginTop:20}}>
      <FormLabel id="demo-row-radio-buttons-group-label">Kitle Tipi</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={this.state.filterType}
        onChange={(a) => this.setState({filterType: a.target.value})}
      >
        <FormControlLabel value={0} control={<Radio />} label="Filtrele" />
        <FormControlLabel value={1} control={<Radio />} label="Manuel" />
        
        
      </RadioGroup>
    </FormControl>

        {this.state.filterType == 0 && <Typography style={{marginTop:20}}>Filtreler</Typography>}
    {this.state.receiverType == 1 && this.state.filterType == 0 && <FormGroup style={{marginTop:5}}>
  <FormControlLabel control={<Checkbox onClick={() => {
    
    if(this.state.filters.vehicles == undefined) {
        this.state.filters.vehicles = {$in: [0,1,2,3,4,5]};
    } else {
        delete this.state.filters.vehicles;
    }
    console.log(this.state.filters.vehicles == undefined);

    this.forceUpdate();
  }} checked={this.state.filters.vehicles != undefined} />} label="Araç Tipine Göre Filtrele" />
  
</FormGroup>}

    {this.state.filterType == 0 && this.state.filters.vehicles != undefined && <div style={{marginTop:8}}>
      <MultiSelectDropdown
        options={vehicleSelectOptions}
        value={this.state.filters.vehicles.$in}
        onChange={(values) => { this.state.filters.vehicles.$in = values; this.forceUpdate(); }}
        placeholder="Araç tipi ara…"
        emptyLabel="Araç tipi seçin…"
        minWidth={320}
        searchable={false}
      />
    </div>}

{this.state.receiverType == 0 && this.state.filterType == 0 && this.renderCustomerFilters()}

{this.state.filterType == 1 && this.state.receiverType != undefined && <>

<Typography style={{marginTop:20,marginBottom:10}}>Üye Seçimi</Typography>
<div style={{marginBottom:20,display:"flex",gap:10,flexWrap:"wrap"}}>{this.state.selectedUsers.map((x, i) => <Chip key={i} label={x.n} onDelete={() => {
    this.state.selectedUsers.splice(i,1);
    this.forceUpdate();
}} />)}</div>
<SearchBarComponent ref={a => this.manualSearch = a} onValueSelected={(v) => {
    if(!v) return;

    if(!this.state.selectedUsers.find((s) => s._id == v._id)) {
    this.state.selectedUsers.push({n: v.label.split(v.type==1?",":":")[1],_id: v._id})
    this.forceUpdate();
    }
    //setTimeout(() => {
        this.manualSearch.setSearchValue("");
    
    
}} search={({drivers: this.state.receiverType == 1, clients: this.state.receiverType == 0, orders: false, applications: false})} />
</>}


{this.state.receiverType == 1 && <FormControl style={{marginTop:20}}>
      <FormLabel id="demo-row-radio-buttons-group-label">Tıklama Aksiyonu</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={this.state.openAction}
        onChange={(a) => this.setState({openAction: a.target.value, data: this.state.data.orderId ? {orderId: this.state.data.orderId} : {}})}
      >
        <FormControlLabel value={0} control={<Radio />} label="Hiçbir şey" />
        <FormControlLabel value={1} control={<Radio />} label="Siparişi Aç" />
        
        
      </RadioGroup>
    </FormControl>}

    


    {this.state.receiverType ==0 && <FormControl style={{marginTop:20}}>
      <FormLabel id="demo-row-radio-buttons-group-label">Tıklama Aksiyonu</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={this.state.openAction}
        onChange={(a) => this.setState({openAction: a.target.value, data: {...(this.state.data.orderId ? {orderId: this.state.data.orderId} : {}), ...(a.target.value == 1 ? {review: 1} : {})}})}
      >
        <FormControlLabel value={0} control={<Radio />} label="Hiçbir şey" />
        <FormControlLabel value={1} control={<Radio />} label="Yorum Yap" />
        
        
      </RadioGroup>
    </FormControl>}
    
    {this.state.openAction == 1 && this.state.receiverType == 1 && <>
    <Typography style={{marginTop:20, marginBottom:5}}>Açılacak Sipariş</Typography>
    <FormControlLabel labelPlacement='start'  control={<SearchBarComponent onValueSelected={(value) => {

        if(value != undefined) {
          this.state.data.orderId = value._id;

          this.state.cityFilter = [value.city];
        } else {
          this.state.data.orderId = undefined;
        }
        console.log(value);
        this.forceUpdate();
    }} search={{orders: 1}}   />} label={this.state.data.orderId?"Sipariş #" + this.state.data.orderId.substring(18).toUpperCase():"Sipariş Seçin"} /></>}


{this.state.filterType == 0 && this.state.receiverType == 1 && <FormControl style={{marginTop:20}}>
      <FormLabel id="demo-row-radio-buttons-group-label">Şehirler</FormLabel>
      <RadioGroup row value={this.state.cityFilter.length == defaultCityFilter.length ? "all" : "select"} onChange={(e) => this.setState({ cityFilter: e.target.value == "all" ? [...defaultCityFilter] : [] })}>
        <FormControlLabel value="all" control={<Radio size="small" />} label="Tüm Şehirler" />
        <FormControlLabel value="select" control={<Radio size="small" />} label="Şehir Seç" />
      </RadioGroup>
      {this.state.cityFilter.length != defaultCityFilter.length && <MultiSelectDropdown
        options={citySelectOptions}
        value={this.state.cityFilter}
        onChange={(values) => this.setState({ cityFilter: values })}
        placeholder="Şehir ara…"
        emptyLabel="Şehir seçin…"
        minWidth={360}
      />}
    </FormControl>}



{/* {this.state.receiverType == 1 && this.state.filterType == 0 && } */}
            </Badge>



            <Badge style={{marginTop:40}}>
              <div style={{display:"flex",flex:1, justifyContent:"space-between"}}>
                <Typography variant='h6'>Bildirim Ayarları</Typography>

                <div style={{display:"flex", gap: 8, alignItems:"center"}}>
      <TextField size="small" label="Şablon adı" value={this.state.templateName} onChange={(e) => this.setState({templateName: e.target.value})} />
      <Button variant="outlined" disabled={!this.state.templateName.trim() || !this.state.title.tr.trim() || !this.state.body.tr.trim()} onClick={() => {
        const reply = {code: this.state.templateName.trim(), type: 1, titleTR: this.state.title.tr, bodyTR: this.state.body.tr, titleEN: this.state.title.en, bodyEN: this.state.body.en};
        API.fetch("savereply", {reply}).then((result) => {
          if (result?._id) {
            global.cache.replies = [...global.cache.replies, {...reply, _id: result._id}];
            this.setState({templateName: ""});
          }
        });
      }}>Şablon olarak kaydet</Button>
      <Button
        id="basic-button"
        aria-controls={this.state.notificationTemplatesDropdownOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={this.state.notificationTemplatesDropdownOpen ? 'true' : undefined}
        onClick={(e) => {
          this.anchorEl = e.currentTarget;
          this.setState({notificationTemplatesDropdownOpen: !this.state.notificationTemplatesDropdownOpen});
        }}
        variant='contained'
      >
        Şablonlar <ArrowDropDownIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={this.anchorEl}
        open={this.state.notificationTemplatesDropdownOpen}
        onClose={() => {
          this.setState({notificationTemplatesDropdownOpen: false});
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {global.cache.replies.filter(s => s.type == 1).map((s) => <MenuItem onClick={() => {
            this.setState({notificationTemplatesDropdownOpen: false, title: {tr: s.titleTR, en: s.titleEN}, body: {tr: s.bodyTR, en: s.bodyEN}});
        }}><div><p style={{textAlign:"right"}}>{s.code}</p><p style={{fontSize:10,textAlign:"right",maxWidth:300, textOverflow:"ellipsis"}}>{s.titleTR + " " + s.bodyTR}</p></div></MenuItem>)}
        
        
      </Menu>
    </div>
    </div>


                {this.state.receiverType == 0 && <Typography variant='body1' style={{marginTop:30,marginBottom:5,fontWeight:"600"}}>Türkçe</Typography>}
                <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Başlık</Typography>
                <TextField value={this.state.title.tr} onChange={(e) => {
                    this.state.title.tr = e.target.value;
                    this.forceUpdate();
                }} size='small' rows={3} multiline onKeyDown={(e) => {
  if(e.keyCode === 13) {
    e.preventDefault();
    
  }
}} />



<Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Metin</Typography>
<TextField value={this.state.body.tr} onChange={(e) => {
                    this.state.body.tr = e.target.value;
                    this.forceUpdate();
                }} size='small' rows={3} multiline onKeyDown={(e) => {
  if(e.keyCode === 13) {
    e.preventDefault();
    
  }
}} />


{this.state.receiverType == 0 && <><Typography variant='body1' style={{marginTop:30,marginBottom:5,fontWeight:"600"}}>İngilizce</Typography>
                <Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Başlık</Typography>
                <TextField value={this.state.title.en} onChange={(e) => {
                    this.state.title.en = e.target.value;
                    this.forceUpdate();
                }} size='small' rows={3} multiline onKeyDown={(e) => {
  if(e.keyCode === 13) {
    e.preventDefault();
    
  }
}} />

<Typography variant='body1' style={{marginTop:10,marginBottom:5}}>Metin</Typography>
<TextField value={this.state.body.en} onChange={(e) => {
                    this.state.body.en = e.target.value;
                    this.forceUpdate();
                }} size='small' rows={3} multiline onKeyDown={(e) => {
  if(e.keyCode === 13) {
    e.preventDefault();
    
  }
}} /></>}

<div style={{marginTop:20, alignSelf:"flex-end"}}>
<Button onClick={() => {
    this.setState({backdropVisible: true});

    var notifications = [{title: this.state.title.tr, body:this.state.body.tr}];
    if(this.state.receiverType == 0 && (this.state.title.en.trim().length+this.state.body.en.trim().length) > 0) notifications.push({title: this.state.title.en, body: this.state.body.en});

    API.fetch("testnotification", {notifications, data: this.state.data}).then((e) => {
        this.setState({backdropVisible: false});
    })
}} variant='outlined' fullWidth={false}>Test Bildirimi Gönder</Button>
</div>
            </Badge>

            {this.state.errorSending != undefined && <div style={{marginTop:10}}>
                <Typography style={{color:"crimson"}}>Bildirimler gönderildiği zaman {this.state.errorSending.length} kişi bu bildirimi alamadı;</Typography>
                <Typography style={{color:"crimson"}}>{this.state.errorSending.join(", ")}</Typography>
            </div>}

            <div style={{alignSelf:"flex-end",display:"flex", justifyContent:"flex-end", marginTop:30}}>
                <div>
                <Button onClick={() => {
                    
                    
                    //if(this.state.filterType == 0) {
                        this.setState({backdropVisible: true});

                        var filters = this.getFilters();
                        API.fetch("notificationgetcount", {receiverType: this.state.receiverType,filters}).then((e) => {
                           
                            this.setState({backdropVisible: false, audienceSize: e, approveSend: true});
                        })
                    //}
                }} fullWidth={false} variant='contained'>Bildirimi Gönder</Button>
                </div>
            </div>
            
            </div>

        <Dialog
        open={this.state.approveSend}
        onClose={() => {
            this.setState({approveSend: false});
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Bu bildirimi yollamak istediğinize emin misiniz?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Seçmiş olduğunuz kitlenin büyüklüyü {this.state.audienceSize[0]}, bunlardan {this.state.audienceSize[1]} kadarı bildirimlerini açmış.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({approveSend: false})}>İptal</Button>
          <Button onClick={() => {
            this.setState({approveSend: false, backdropVisible: true})
            
            
            API.fetch("sendnotifications", {filters: this.getFilters(),receiverType: this.state.receiverType, data: this.state.data, title: this.state.title, body: this.state.body}).then((e) => {
                this.setState({backdropVisible: false,errorSending: e.errorSending});

                console.log(e)
            })
          }} autoFocus>
            Yolla
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={this.state.backdropVisible}
  
>
  <CircularProgress color="inherit" />
</Backdrop>
        </div>
    }


    getFilters() {
        var filters = {...this.state.filters};

    if(this.state.receiverType == 1 && this.state.filters.vehicles) {
        
      filters.vehicles = {$elemMatch: {type:  filters.vehicles}};
      
      if(this.state.filters.vehicles.$in && this.state.filters.vehicles.$in.includes(6)) {
        filters.$or = [{vehicles: filters.vehicles}, {flexible: true}];
        delete filters.vehicles;
      }

      
    }

    if(this.state.receiverType == 1 && this.state.filterType == 0) {
      filters.city = {$in: this.state.cityFilter};
    }
    if(this.state.receiverType == 0 && this.state.filterType == 0) {
        filters = this.getCustomerFilters();
    }
    if(this.state.filterType == 1) {
        filters._id = {$in: this.state.selectedUsers.map((x) => x._id)}
    }
    
    
    return filters;
    }

    getCustomerFilters() {
      const customerFilters = this.state.customerFilters || getDefaultCustomerFilters();
      const filters = {};

      if(customerFilters.cities.length > 0 && customerFilters.cities.length != defaultCityFilter.length) {
        filters.cities = [...customerFilters.cities];
      }

      if(customerFilters.districts.length > 0) {
        filters.districts = [...customerFilters.districts];
      }

      if(customerFilters.customerKind != "all") {
        filters.customerKind = customerFilters.customerKind;
      }

      if(customerFilters.customerKind == "corporate" && customerFilters.companyIds.length > 0) {
        filters.companyIds = [...customerFilters.companyIds];
      }

      if(customerFilters.hasPlacedOrder == "yes") {
        filters.hasPlacedOrder = true;
      } else if(customerFilters.hasPlacedOrder == "no") {
        filters.hasPlacedOrder = false;
      }

      if(customerFilters.lastOrderOlderThanDays) {
        filters.lastOrderOlderThanDays = parseInt(customerFilters.lastOrderOlderThanDays);
      }

      if(customerFilters.orderTypes.length > 0) {
        filters.orderTypes = [...customerFilters.orderTypes];
      }

      if(customerFilters.platforms.length > 0) {
        filters.platforms = [...customerFilters.platforms];
      }

      if(customerFilters.languages.length > 0) {
        filters.languages = [...customerFilters.languages];
      }

      const campaignCode = customerFilters.campaignCode.trim().toUpperCase();
      if(campaignCode.length > 0) {
        if(customerFilters.campaignStatus == "used") filters.usedCampaignCodes = [campaignCode];
        if(customerFilters.campaignStatus == "unused") filters.unusedCampaignCodes = [campaignCode];
      }

      return filters;
    }

    setCustomerFilter(key, value) {
      this.setState({
        customerFilters: {
          ...this.state.customerFilters,
          [key]: value,
        }
      });
    }

    toggleCustomerArrayValue(key, value, checked) {
      const currentValues = this.state.customerFilters[key] || [];
      let nextValues = currentValues;

      if(checked && !currentValues.includes(value)) nextValues = [...currentValues, value];
      if(!checked) nextValues = currentValues.filter((x) => x != value);

      this.setCustomerFilter(key, nextValues);
    }

    getCustomerDistrictOptions() {
      const selectedCityIds = this.state.customerFilters?.cities || [];
      const scopedCities = cityOptions.filter((city) => selectedCityIds.includes(city.id));

      return scopedCities.flatMap((city) => (city.ilceler || []).map((district) => ({
        cityId: city.id,
        cityName: city.name,
        district,
        key: `${city.id}-${district}`
      })));
    }

    renderCustomerFilters() {
      const customerFilters = this.state.customerFilters || getDefaultCustomerFilters();
      const districtOptions = this.getCustomerDistrictOptions();
      const hasCampaignCode = customerFilters.campaignCode.trim().length > 0;

      return <>
        <Typography style={{marginTop:20, fontWeight:700, fontSize:14}}>Bölgeler</Typography>
        <div style={{display:"flex", gap:16, flexWrap:"wrap", marginTop:8}}>
          <MultiSelectDropdown
            label="Şehirler"
            options={citySelectOptions}
            value={customerFilters.cities}
            onChange={(nextCities) => {
              const allowedDistricts = getDistrictsForCityIds(nextCities);
              this.setState({
                customerFilters: {
                  ...customerFilters,
                  cities: nextCities,
                  districts: customerFilters.districts.filter((district) => allowedDistricts.includes(district)),
                }
              });
            }}
            placeholder="Şehir ara…"
            emptyLabel="Şehir seçin…"
            minWidth={320}
          />
          <MultiSelectDropdown
            label="İlçeler (İsteğe bağlı)"
            options={districtOptions.map((option) => ({ value: option.district, label: `${option.district} (${option.cityName})` }))}
            value={customerFilters.districts}
            onChange={(values) => this.setCustomerFilter("districts", values)}
            placeholder="İlçe ara…"
            emptyLabel={districtOptions.length > 0 ? "İlçe seçin…" : "Önce şehir seçin"}
            disabled={districtOptions.length === 0}
            minWidth={320}
          />
        </div>

        <FormControl style={{marginTop:20, minWidth:260}}>
          <FormLabel>Müşteri Tipi</FormLabel>
          <Select
            size='small'
            value={customerFilters.customerKind}
            onChange={(e) => this.setState({
              customerFilters: {
                ...customerFilters,
                customerKind: e.target.value,
                companyIds: e.target.value == "corporate" ? customerFilters.companyIds : [],
              }
            })}
          >
            <MenuItem value="all">Tümü</MenuItem>
            <MenuItem value="corporate">Kurumsal</MenuItem>
            <MenuItem value="individual">Bireysel</MenuItem>
          </Select>
        </FormControl>

        {customerFilters.customerKind == "corporate" && <FormControl style={{marginTop:20, minWidth:320}}>
          <FormLabel>Kurumsal Müşteriler</FormLabel>
          <Select
            multiple
            size='small'
            value={customerFilters.companyIds}
            renderValue={(selected) => this.state.businesses.filter((business) => selected.includes(String(business._id))).map((business) => business.name).join(", ")}
            onChange={(e) => this.setCustomerFilter("companyIds", e.target.value)}
          >
            {this.state.businessesLoading && <MenuItem disabled>Yükleniyor...</MenuItem>}
            {!this.state.businessesLoading && this.state.businesses.map((business) => <MenuItem key={business._id} value={String(business._id)}>{business.name}</MenuItem>)}
          </Select>
        </FormControl>}

        <FormControl style={{marginTop:20, minWidth:260}}>
          <FormLabel>Sipariş Geçmişi</FormLabel>
          <Select
            size='small'
            value={customerFilters.hasPlacedOrder}
            onChange={(e) => this.setState({
              customerFilters: {
                ...customerFilters,
                hasPlacedOrder: e.target.value,
                lastOrderOlderThanDays: e.target.value == "yes" ? customerFilters.lastOrderOlderThanDays : "",
              }
            })}
          >
            <MenuItem value="all">Tümü</MenuItem>
            <MenuItem value="yes">En az bir sipariş vermiş</MenuItem>
            <MenuItem value="no">Hiç sipariş vermemiş</MenuItem>
          </Select>
        </FormControl>

        <FormControl style={{marginTop:20, minWidth:260}}>
          <FormLabel>Son Sipariş</FormLabel>
          <Select
            size='small'
            value={customerFilters.lastOrderOlderThanDays}
            disabled={customerFilters.hasPlacedOrder == "no"}
            onChange={(e) => this.setCustomerFilter("lastOrderOlderThanDays", e.target.value)}
          >
            <MenuItem value="">Filtreleme</MenuItem>
            <MenuItem value={30}>30+ gün</MenuItem>
            <MenuItem value={60}>60+ gün</MenuItem>
            <MenuItem value={90}>90+ gün</MenuItem>
          </Select>
        </FormControl>

        <FormControl style={{marginTop:20}}>
          <FormLabel>Sipariş Tipi</FormLabel>
          <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap"}}>
            {CUSTOMER_ORDER_TYPE_OPTIONS.map((option) => <FormControlLabel
              key={option.value}
              control={<Checkbox
                checked={customerFilters.orderTypes.includes(option.value)}
                onChange={(e, checked) => this.toggleCustomerArrayValue("orderTypes", option.value, checked)}
              />}
              label={option.label}
            />)}
          </div>
        </FormControl>

        <FormControl style={{marginTop:20}}>
          <FormLabel>Platform</FormLabel>
          <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap"}}>
            {PLATFORM_OPTIONS.map((option) => <FormControlLabel
              key={option.value}
              control={<Checkbox
                checked={customerFilters.platforms.includes(option.value)}
                onChange={(e, checked) => this.toggleCustomerArrayValue("platforms", option.value, checked)}
              />}
              label={option.label}
            />)}
          </div>
        </FormControl>

        <FormControl style={{marginTop:20}}>
          <FormLabel>Uygulama Dili</FormLabel>
          <div style={{display:"flex", flexDirection:"row", flexWrap:"wrap"}}>
            {LANGUAGE_OPTIONS.map((option) => <FormControlLabel
              key={option.value}
              control={<Checkbox
                checked={customerFilters.languages.includes(option.value)}
                onChange={(e, checked) => this.toggleCustomerArrayValue("languages", option.value, checked)}
              />}
              label={option.label}
            />)}
          </div>
        </FormControl>

        <div style={{display:"flex", gap:16, flexWrap:"wrap", marginTop:20}}>
          <FormControl style={{minWidth:220}}>
            <FormLabel>Kampanya Durumu</FormLabel>
            <Select
              size='small'
              value={customerFilters.campaignStatus}
              onChange={(e) => this.setCustomerFilter("campaignStatus", e.target.value)}
            >
              <MenuItem value="unused">Kullanılmamış</MenuItem>
              <MenuItem value="used">Kullanılmış</MenuItem>
            </Select>
          </FormControl>

          <div style={{display:"flex", flexDirection:"column", minWidth:220}}>
            <Typography variant='body2' style={{marginBottom:5}}>Kampanya Kodu</Typography>
            <TextField
              size='small'
              value={customerFilters.campaignCode}
              onChange={(e) => this.setCustomerFilter("campaignCode", e.target.value.toUpperCase())}
              placeholder='APP10'
            />
          </div>
        </div>

        {hasCampaignCode && <Typography variant='body2' style={{marginTop:8, color:"#64748b"}}>
          Kod girildiğinde backend {customerFilters.campaignStatus == "used" ? "kullanmış" : "kullanmamış"} müşterileri hedefler.
        </Typography>}
      </>
    }
}




var dateFromObjectId = function (objectId) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

const Badge = (props) => {
    return <div style={{backgroundColor:"white",display:"flex",flexDirection:"column", flex:1,boxShadow:"rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px", borderRadius:8,padding:24, color:"rgb(18, 24, 40)",...props.style}}>
        {props.children}
    </div>
}

function diacriticSensitiveRegex(string = '') {
  return '' + (string.replace(/\+/g,'').replace(/[Iİıi]/g, '[I,İ,ı,i]').replace(/[öÖoO]/g, '[ö,Ö,o,O]').replace(/[şŞsS]/g, '[ş,Ş,s,S]').replace(/[çÇcC]/g, '[ç,Ç,c,C]').replace(/[ğĞgG]/g, '[ğ,Ğ,g,G]').replace(/[uUÜü]/g, '[u,U,Ü,ü]')).split(/\,|\s/).join(' ') + ''
 }

const PLATFORM_OPTIONS = [
  {value: "android", label: "Android"},
  {value: "ios", label: "iOS"},
  {value: "web", label: "Web"},
];

const LANGUAGE_OPTIONS = [
  {value: "tr", label: "Türkçe"},
  {value: "en", label: "İngilizce"},
];

const CUSTOMER_ORDER_TYPE_OPTIONS = [
  {value: "flexible", label: "Esnek Hizmet"},
  {value: "standard_vehicle", label: "Standart Araç"},
];

function getDefaultCustomerFilters() {
  return {
    // Empty = every city (the dropdown starts with nothing selected, ADM-04).
    cities: [],
    districts: [],
    customerKind: "all",
    companyIds: [],
    hasPlacedOrder: "all",
    lastOrderOlderThanDays: "",
    orderTypes: [],
    platforms: [],
    languages: [],
    campaignStatus: "unused",
    campaignCode: "",
  };
}

function getDistrictsForCityIds(cityIds) {
  return cityOptions
    .filter((city) => cityIds.includes(city.id))
    .flatMap((city) => city.ilceler || []);
}
